//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bookassignment/edit/loadscreenview", vo, successCallback, failureCallback);
    },
    saveBookAssignment: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/bookassignment/edit/save", vo, successCallback, failureCallback);
    },
};

export default EditService;